export default __webpack_public_path__ + "static/partner2-fd7da49f953636451032ed98be0931ae.png";